/**
 * Centralised API route prefixes for the gateway — Donor Portal.
 *
 * Every backend micro-service is reached through the gateway at:
 *   <base-url>/<SERVICE_PREFIX>/api/<VERSION>/…
 */

const API_VERSION = 'v1';

function servicePrefix(service: string): string {
  return `/${service}/api/${API_VERSION}`;
}

export const API_ROUTES = {
  /** tms-api-allergens — allergen & severity lookups */
  ALLERGENS: servicePrefix('allergens'),

  /** tms-api-facilities — locations, care-units, beds */
  FACILITIES: servicePrefix('facilities'),

  /** tms-api-patient — patients, assignments, milk-providers, links, documents */
  PATIENT: servicePrefix('patient'),

  /** tms-api-products — product catalogue & lookups */
  PRODUCTS: servicePrefix('products'),

  /** tms-api-milk-mgmt — milk batches, pools, pasteurisation */
  MILK_MANAGEMENT: servicePrefix('milkManagement'),

  /** tms-api-inventoryManagement — milk receivables, inventory tracking */
  INVENTORY_MANAGEMENT: servicePrefix('inventoryManagement'),

  /** tms-api-service — auth, staff, legacy endpoints */
  SERVICE: servicePrefix('service'),

  /** tms-api-feedManagement — feed administration, quick-feed, re-dosing */
  FEED_MANAGEMENT: servicePrefix('feedManagement'),

  /** tms-api-onboarding — tenant user onboarding */
  ONBOARDING: servicePrefix('onboarding'),

  /** tms-api-settings — help desk, app settings */
  SETTINGS: servicePrefix('settings'),

  /** tms-api-locale — localization / translation bundles */
  LOCALE: servicePrefix('locale'),

  /** tms-api-reports — feed-order reports, CSV/Excel export */
  REPORTS: servicePrefix('reports'),

  /** tms-api-donor — donor-specific endpoints */
  DONOR: servicePrefix('donorPortal'),
} as const;

export type ServiceKey = keyof typeof API_ROUTES;
